import React from "react";
import Side from "./Side";
import Adminheader from "./AdminHeader";
// import { useTheme } from "../Context/ThemeContext";
import "../Admin/Admin.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Main = (props) => {
  return (
    <div>
      <div className="dash">
        <div className="admin-all">
          <div className="admin-sidebar-display">
            <div className="left-side">
              <Side />
            </div>
          </div>

          <div className="right-admin main-content">
            <Adminheader />
            {props.children}
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default Main;
